export const FirebaseConfig = {
	appId:             process.env.NEXT_PUBLIC_FIREBASE_APP_ID || '',
	measurementId:     process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || '',
	messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '',
	projectId:         process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || '',
	apiKey:            process.env.NEXT_PUBLIC_FIREBASE_API_KEY || '',
	authDomain:        process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || '',
	storageBucket:     process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || '',
};
